module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('textarea', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: (_vm.validators),
      expression: "validators"
    }],
    staticClass: "form-control",
    attrs: {
      "data-vv-as": _vm.field.description.replace(/\./g, ''),
      "id": _vm.field.name,
      "name": _vm.field.name,
      "readonly": _vm.locked,
      "minlength": _vm.field.minSize,
      "maxlength": _vm.field.maxSize,
      "rows": "6"
    },
    domProps: {
      "value": _vm.value
    },
    on: {
      "input": _vm.input
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5d1b0d92","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/formbuilder/render/TextareaRender.vue
// module id = 1658
// module chunks = 1